<template>
  <section>
    <div
      v-if="dataTable.length > 0"
      class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2"
    >
      <div
        class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white"
      >
        <div class="p-1 flex">
          <DropDownOptions
            v-model="selectedFilter"
            :label="'Filtrar'"
            :icon="PhFunnel"
            :options="['Todos', 'em dia', 'a vencer', 'vencidos']"
          />
        </div>

        <SearchInput v-model="searchTerm" />
      </div>

      <DataTable
        :data="filteredData"
        @delete="deleteItem($event)"
        @export-excel="exportExcel($event)"
      >
        <template #head>
          <th scope="col" class="px-6 py-3">Tipo</th>
          <th scope="col" class="px-6 py-3">Localização</th>
          <th scope="col" class="px-6 py-3">Status</th>
          <th scope="col" class="px-6 py-3">Prox. Inspeção</th>
          <th
            title="Vencimento do teste Hidrostático"
            scope="col"
            class="px-6 py-3"
          >
            Venc. do TH
          </th>
          <th scope="col" class="px-6 py-3 text-center">#</th>
        </template>
      </DataTable>
    </div>

    <NoDataAnim v-else :label="'Nenhum item cadastrado'" />
  </section>
</template>

<script setup>
import DataTable from './../../components/_partials/DataTableExtin.vue'
import DropDownOptions from '@/components/Tables/DropDownOptions.vue'
import ExtinguisherService, { PATH } from '../../service/extinguisher.service'
import SearchInput from '@/components/Tables/SearchInput.vue'
import NoDataAnim from '@/components/Lotties/NoDataAnim.vue'
import moment from 'moment'
import { showToast as toast } from '@/helpers/UseToasts'
import { computed, onMounted, ref } from 'vue'
import { dataExtinguisher } from '../../store'
import { initFlowbite } from 'flowbite'
import { storeApp } from '@/store'

import { PhFunnel } from '@phosphor-icons/vue'
import { PdfCreate } from '@/utils/reports/generate-blob'

const store = dataExtinguisher
const searchTerm = ref('')
const selectedFilter = ref('')

const dataTable = computed(() => {
  return store.getters?.getItensBySector.map((row) => {
    const valueData = row.values ? JSON.parse(row.values) : {}

    let status = ''
    let categoria = ''

    if (valueData[0]?.category) categoria = valueData[0]?.category?.value

    if (row.next_check !== null) { status = calculateStatus(row.next_check) } else if (row.expired_at !== null) { status = calculateStatus(row.expired_at) } else status = { status: 'em cadastro', next: 'não informado' }

    const data = {
      ...row,
      ...status,
      obs: valueData[0],
      categoria
    }

    return data
  })
})

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase()

  return dataTable.value.filter((row) => {
    if (selectedFilter.value === 'Todos') selectedFilter.value = ''

    const matchesDropdown =
      !selectedFilter.value || row.status === selectedFilter.value

    const matchesSearch =
      !searchTerm.value ||
      ['name', 'type', 'categoria', 'status'].some(
        (key) =>
          row[key] &&
          row[key].toString().toLowerCase().includes(searchTermLower)
      )

    return matchesDropdown && matchesSearch
  })
})

function formatDate (date) {
  return moment(date).format('D/MM/Y')
}

function calculateStatus (nextCheck) {
  const today = moment()
  const expirationDate = moment(nextCheck)
  const daysDiff = expirationDate.diff(today, 'days')

  if (daysDiff < 0) {
    return { status: 'vencido', next: 'Hoje' }
  } else if (daysDiff <= 30) {
    return { status: 'a vencer', next: daysDiff }
  } else {
    return { status: 'em dia', next: daysDiff }
  }
}

async function exportExcel (id) {
  storeApp.state.loading = true

  const url = `${process.env.VUE_APP_API_URL}${PATH}itens/${id}/export-excel`
  const report = new PdfCreate(url)

  return await report.fetchExcelByItemId(id).finally(() => {
    storeApp.state.loading = false
  })
}

async function deleteItem (event) {
  storeApp.state.loading = true
  const confirm = window.confirm('Deseja realmente desativar este item?')
  if (confirm) {
    Promise.allSettled([
      ExtinguisherService.removeItem(event.id, event.sectorId).catch((err) => {
        if (
          (err?.response?.data?.error && err.response.data.status === 400) ||
          err.response.data.status === 404
        ) {
          return toast('Aviso', err.response.data.message, 'error')
        }

        toast('Aviso', 'Algo deu errado ao desativar item', 'error')
      })
    ])

    await ExtinguisherService.allExtinguishersBySector(event.sectorId)
      .then((res) => {
        if (res?.data[0]) { dataExtinguisher.dispatch('setItemsBySector', res?.data[0]?.itens) }

        toast('Sucesso', 'Item desativado', 'success')
      })
      .catch((err) => {
        storeApp.state.loading = false

        if (err?.response?.data?.error && err.response.data.status === 400) {
          return toast('Aviso', err.response.data.message, 'error')
        }

        return toast('Aviso', 'Algo deu errado ao remover setor', 'error')
      })
  }

  storeApp.state.loading = false
}

onMounted(() => {
  initFlowbite()
  store.dispatch('setBackComponent', 'SectorsList')
})
</script>
